import React from 'react';
import { makeStyles, LinearProgress } from '@material-ui/core';
import { BrandColors } from '../../constants';
import { getPasswordStrength } from '../utils/validation';
import { StrengthMeter } from '../interfaces/AuthInputFields';

/** Method to get color code by strength */
const getColorByPasswordStrength = (strength: StrengthMeter): string => {
  let strengthColor: string = BrandColors.grey77;
  const { variations, charCount, score } = strength;

  if (score <= 0) {
    strengthColor = BrandColors.grey77;
  }
  if (
    !variations.digits ||
    !variations.lower ||
    !variations.upper ||
    charCount <= 8 ||
    charCount >= 50 ||
    !variations.moreThanTwoConsecutiveCharacters
  ) {
    strengthColor = BrandColors.red39;
  }
  if (
    variations.digits &&
    variations.lower &&
    variations.upper &&
    charCount >= 8 &&
    charCount < 50 &&
    variations.moreThanTwoConsecutiveCharacters
  ) {
    strengthColor = BrandColors.green20;
  }
  return strengthColor;
};

/** Style override to set bar color by strength */
const useStyles = makeStyles({
  root: {
    backgroundColor: `${BrandColors.grey77} !important`,
    borderRadius: '50px',
    height: '0.75rem',
  },
  barColorPrimary: {
    backgroundColor: (strength: StrengthMeter): string => getColorByPasswordStrength(strength),
  },
});

/** Type for password strength meter component  */
type PasswordStrengthMeterProps = {
  password: string;
};

/** Component for password strength meter with color as per strength */
export const PasswordStrengthMeter = ({ password }: PasswordStrengthMeterProps): JSX.Element => {
  const passwordStrength: StrengthMeter = getPasswordStrength(password);
  const classes = useStyles(passwordStrength);

  return <LinearProgress variant="determinate" value={passwordStrength.score} classes={classes} />;
};
